import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',

    '& img': {
      margin: theme.spacing(2),
    },

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 20),
    },
  },
}));
